/* @ts-ignore */
import * as Types from '../../../graphql/generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type NewAppsDiscoveryTrendQueryVariables = Types.Exact<{
  dateFrom: Types.Scalars['Date']['input'];
  dateTo: Types.Scalars['Date']['input'];
  grain?: Types.InputMaybe<Types.NewAppsDiscoveryTrendGrain>;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type NewAppsDiscoveryTrendQuery = { __typename: 'Query', newAppsDiscoveryTrend?: { __typename: 'NewAppsDiscoveryTrendType', totalCount: number, points: Array<{ __typename: 'NewAppsDiscoveryTrendPointType', date: any, count: number }>, byTenant: Array<{ __typename: 'NewAppsDiscoveryTenantContributionType', clientId: string, clientName: string, count: number }> } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const NewAppsDiscoveryTrendDocument = new TypedDocumentString(`
    query NewAppsDiscoveryTrend($dateFrom: Date!, $dateTo: Date!, $grain: NewAppsDiscoveryTrendGrain, $clientId: UUID) {
  newAppsDiscoveryTrend(
    dateFrom: $dateFrom
    dateTo: $dateTo
    grain: $grain
    clientId: $clientId
  ) {
    totalCount
    points {
      date
      count
    }
    byTenant {
      clientId
      clientName
      count
    }
  }
}
    `);

export const useNewAppsDiscoveryTrendQuery = <
      TData = NewAppsDiscoveryTrendQuery,
      TError = unknown
    >(
      variables: NewAppsDiscoveryTrendQueryVariables,
      options?: Omit<UseQueryOptions<NewAppsDiscoveryTrendQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NewAppsDiscoveryTrendQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NewAppsDiscoveryTrendQuery, TError, TData>(
      {
    queryKey: ['NewAppsDiscoveryTrend', variables],
    queryFn: fetcher<NewAppsDiscoveryTrendQuery, NewAppsDiscoveryTrendQueryVariables>(NewAppsDiscoveryTrendDocument, variables),
    ...options
  }
    )};

useNewAppsDiscoveryTrendQuery.getKey = (variables: NewAppsDiscoveryTrendQueryVariables) => ['NewAppsDiscoveryTrend', variables];

export const useInfiniteNewAppsDiscoveryTrendQuery = <
      TData = InfiniteData<NewAppsDiscoveryTrendQuery>,
      TError = unknown
    >(
      variables: NewAppsDiscoveryTrendQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NewAppsDiscoveryTrendQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NewAppsDiscoveryTrendQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NewAppsDiscoveryTrendQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['NewAppsDiscoveryTrend.infinite', variables],
      queryFn: (metaData) => fetcher<NewAppsDiscoveryTrendQuery, NewAppsDiscoveryTrendQueryVariables>(NewAppsDiscoveryTrendDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNewAppsDiscoveryTrendQuery.getKey = (variables: NewAppsDiscoveryTrendQueryVariables) => ['NewAppsDiscoveryTrend.infinite', variables];


useNewAppsDiscoveryTrendQuery.fetcher = (variables: NewAppsDiscoveryTrendQueryVariables) => fetcher<NewAppsDiscoveryTrendQuery, NewAppsDiscoveryTrendQueryVariables>(NewAppsDiscoveryTrendDocument, variables);
